module.exports = __webpack_public_path__ + "img/result-detail-output-inright02.4670cb03.svg";